import { TransportFilterName } from '../constants';

export class TransportFiltersLoad {
  public static readonly type = '[TransportFilters] Load';
}

export class TransportFiltersUpdate {
  public static readonly type = '[TransportFilters] Update';
  constructor(public payload: TransportFilterName[]) {}
}

export class TransportFiltersInitialState {
  public static readonly type = '[TransportFilters] Set Initial State';
}
